<div class="container">
  <!-- 1. Heading and Close Button -->
  <div class="heading-container">
    <p class="heading" i18n>Share</p>
    <button class="close-btn" (click)="onCancel()" aria-label="Close dialog">×</button>
  </div>

  <!-- 2. Dynamic Selection Summary -->
  <div class="selection-summary-container">
    <div class="items-preview">
      <div
        *ngFor="let item of Ids.slice(0, displayLimit); let i = index"
        class="item-box"
        [style.background-color]="getColor(i)"
        [style.z-index]="displayLimit - i"
      >
        <!-- Icon SVG -->
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.31725 13.9902C7.10475 13.9902 6.92658 13.9184 6.78275 13.7747C6.63908 13.6309 6.56725 13.4527 6.56725 13.24C6.56725 13.0275 6.63908 12.8494 6.78275 12.7058C6.92658 12.5623 7.10475 12.4905 7.31725 12.4905H8.91325C9.12575 12.4905 9.30392 12.5623 9.44775 12.706C9.59142 12.8498 9.66325 13.0281 9.66325 13.2408C9.66325 13.4532 9.59142 13.6313 9.44775 13.775C9.30392 13.9185 9.12575 13.9902 8.91325 13.9902H7.31725ZM6.49975 19C5.20692 19 4.10492 18.5493 3.19375 17.648C2.28242 16.7468 1.82675 15.6526 1.82675 14.3652V5.327C1.32158 5.327 0.890833 5.15033 0.5345 4.797C0.178167 4.44383 0 4.01467 0 3.5095V1.827C0 1.3245 0.178833 0.894416 0.5365 0.536749C0.894333 0.178916 1.32442 0 1.82675 0H11.1633C11.6683 0 12.1006 0.178916 12.4603 0.536749C12.8199 0.894416 12.9998 1.3245 12.9998 1.827V3.5095C12.9998 4.01467 12.8199 4.44383 12.4603 4.797C12.1006 5.15033 11.6683 5.327 11.1633 5.327V8.2595C11.1633 8.75667 10.9863 9.18225 10.6323 9.53625C10.2783 9.89025 9.85267 10.0673 9.3555 10.0673H7.31725C7.10475 10.0673 6.92658 9.99533 6.78275 9.8515C6.63908 9.70767 6.56725 9.5295 6.56725 9.317C6.56725 9.10433 6.63908 8.92625 6.78275 8.78275C6.92658 8.63908 7.10475 8.56725 7.31725 8.56725H9.66325V5.327H3.32675V14.3652C3.32675 15.2436 3.6355 15.9856 4.253 16.5913C4.8705 17.1971 5.62025 17.5 6.50225 17.5C6.81992 17.5 7.12425 17.4568 7.41525 17.3703C7.70625 17.2838 7.978 17.1591 8.2305 16.9963C8.396 16.8949 8.57325 16.868 8.76225 16.9155C8.95142 16.9628 9.09608 17.0743 9.19625 17.25C9.30892 17.4257 9.34008 17.617 9.28975 17.824C9.23942 18.031 9.12608 18.1909 8.94975 18.3038C8.58575 18.5243 8.20142 18.6954 7.79675 18.8173C7.39225 18.9391 6.95992 19 6.49975 19ZM1.82675 3.827H11.1633C11.2531 3.827 11.3316 3.7965 11.3988 3.7355C11.4661 3.67467 11.4998 3.59933 11.4998 3.5095V1.827C11.4998 1.73717 11.4661 1.66025 11.3988 1.59625C11.3316 1.53208 11.2531 1.5 11.1633 1.5H1.82675C1.73708 1.5 1.66017 1.53208 1.596 1.59625C1.53183 1.66025 1.49975 1.73717 1.49975 1.827V3.5095C1.49975 3.59933 1.53183 3.67467 1.596 3.7355C1.66017 3.7965 1.73708 3.827 1.82675 3.827ZM14.6633 16.6538C15.4018 16.6538 16.0287 16.3961 16.544 15.8807C17.0595 15.3654 17.3173 14.7385 17.3173 14C17.3173 13.2615 17.0595 12.6346 16.544 12.1193C16.0287 11.6039 15.4018 11.3463 14.6633 11.3463C13.9248 11.3463 13.2978 11.6039 12.7825 12.1193C12.2672 12.6346 12.0095 13.2615 12.0095 14C12.0095 14.7385 12.2672 15.3654 12.7825 15.8807C13.2978 16.3961 13.9248 16.6538 14.6633 16.6538ZM14.6633 18.1538C13.5094 18.1538 12.5287 17.7499 11.721 16.9423C10.9133 16.1346 10.5095 15.1538 10.5095 14C10.5095 12.8462 10.9133 11.8654 11.721 11.0577C12.5287 10.2501 13.5094 9.84625 14.6633 9.84625C15.8171 9.84625 16.7978 10.2501 17.6055 11.0577C18.4132 11.8654 18.817 12.8462 18.817 14C18.817 14.4288 18.7539 14.8412 18.6278 15.237C18.5014 15.6328 18.3152 16.0077 18.069 16.3615L20.2903 18.5828C20.4286 18.7213 20.4978 18.8937 20.4978 19.1C20.4978 19.3063 20.4286 19.4788 20.2903 19.6173C20.1518 19.7558 19.9772 19.825 19.7665 19.825C19.5558 19.825 19.3823 19.7558 19.246 19.6173L17.0247 17.4058C16.6709 17.6519 16.2961 17.8382 15.9003 17.9645C15.5044 18.0907 15.0921 18.1538 14.6633 18.1538Z"
            fill="#1C1B1F"
          />
        </svg>
      </div>
    </div>
    <div *ngIf="Ids.length > displayLimit" class="more-box">+{{ Ids.length - displayLimit }}</div>
    <span class="items-count-text" i18n> {{ Ids.length }} {{ title }}{{ Ids.length === 1 ? '' : 's' }} Selected </span>
  </div>

  <!-- 3. Form with Dropdown -->
  <form [formGroup]="shareForm" class="form-body">
    <app-searchable-multi-select
      label="Select Project/Group"
      placeholder="Select Project(s)"
      [options]="allGroups"
      [formControl]="teamControl"
      [multiple]="true"
    >
    </app-searchable-multi-select>
  </form>

  <!-- 4. Footer Actions -->
  <div class="footer-actions">
    <app-buttons
      [name]="buttonCancel"
      [buttonType]="btnMat"
      [buttonStyle]="btnStyleText"
      (buttonClickEvent)="onCancel()"
    >
    </app-buttons>
    <app-buttons
      [isDisabled]="isSubmitting || !teamControl.value?.length"
      [name]="buttonShare"
      [buttonType]="btnMatFlat"
      [buttonStyle]="
        isSubmitting || !teamControl.value?.length
          ? btnStyleFilledSmallForPrimaryBtnDisabled
          : btnStyleFilledSmallForPrimaryBtn
      "
      (buttonClickEvent)="onShare()"
    >
    </app-buttons>
  </div>
</div>
